

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getAllCustomersStatus
// GETALLCUSTOMERSSTATUS
const GETALLCUSTOMERSSTATUS= createAsyncThunk(
  "getAllCustomersStatus/getAllCustomersStatus",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllCustomersStatusSlice = createSlice({
  name: "getAllCustomersStatusSlice",
  initialState: {
    getAllCustomersStatus: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllCustomersStatus: (state) => {
        state.getAllCustomersStatus.loading = false
        state.getAllCustomersStatus.error = false
        state.getAllCustomersStatus.data = []
        state.getAllCustomersStatus.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLCUSTOMERSSTATUS.fulfilled, (state, action) => {
      state.getAllCustomersStatus = {
        ...state.getAllCustomersStatus,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCUSTOMERSSTATUS.pending, (state, action) => {
      state.getAllCustomersStatus = {
        ...state.getAllCustomersStatus,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCUSTOMERSSTATUS.rejected, (state, action) => {
      state.getAllCustomersStatus = {
        ...state.getAllCustomersStatus,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllCustomersStatusAction = {
    GETALLCUSTOMERSSTATUS,
};

export { getAllCustomersStatusAction };
export default getAllCustomersStatusSlice.reducer;
export const {setInitialStateOfgetAllCustomersStatus} = getAllCustomersStatusSlice.actions